import PropTypes from 'prop-types';
import { BulkActions } from '../enums/bulk-actions';
import { ShipmentConfigurationPropType } from './shipment-configuration';
import { ErrorPropType } from './error';

const bulkActionErrorMapShape = Object.values(BulkActions).reduce(
  (acc, bulkAction) => ({
    ...acc,
    [bulkAction.name]: PropTypes.arrayOf(ErrorPropType),
  }),
  {},
);

export const BulkUpdateModelPropType = PropTypes.shape({
  shippingConfiguration: ShipmentConfigurationPropType,
  errors: PropTypes.shape(bulkActionErrorMapShape),
});

/**
 * @typedef {object} BulkUpdateModelPropType
 * @property {ShipmentConfigurationPropType} shippingConfiguration
 * @property {object} errors
 * @property {ErrorPropType[]} errors.addNote
 * @property {ErrorPropType[]} errors.addTaxIdentifiers
 * @property {ErrorPropType[]} errors.applyShippingPreset
 * @property {ErrorPropType[]} errors.assignTo
 * @property {ErrorPropType[]} errors.confirmation
 * @property {ErrorPropType[]} errors.customFieldOne
 * @property {ErrorPropType[]} errors.customFieldTwo
 * @property {ErrorPropType[]} errors.customFieldThree
 * @property {ErrorPropType[]} errors.customsDeclarations
 * @property {ErrorPropType[]} errors.doNotNotifyMarketplace
 * @property {ErrorPropType[]} errors.emailTemplate
 * @property {ErrorPropType[]} errors.insurance
 * @property {ErrorPropType[]} errors.otherShippingOptions
 * @property {ErrorPropType[]} errors.packageBulkAction
 * @property {ErrorPropType[]} errors.packingSlipTemplate
 * @property {ErrorPropType[]} errors.service
 * @property {ErrorPropType[]} errors.shipByDate
 * @property {ErrorPropType[]} errors.shipFrom
 * @property {ErrorPropType[]} errors.shippingAccount
 * @property {ErrorPropType[]} errors.size
 * @property {ErrorPropType[]} errors.weight
 * @property {ErrorPropType[]} errors.adjustWeight
 * @property {ErrorPropType[]} errors.dutiesAndTaxes
 */
